import { Api } from "./Api";
import axios from "axios";
import { ImportMetadata } from "../models/ImportMetadata";
import _ from "lodash";

export class ImportMetadataApi extends Api {
    constructor() {
        super("document/import-metadata");
    }

    getAll(params?: Object): Promise<Api.CallResponse> {
        return this.getResources(params).then(function (response) {
            let res: Array<ImportMetadata> = [];
            if (response.data && response.data.data) {
                res = _.map(response.data.data, function (m) {
                    return new ImportMetadata(m);
                });
            }
            return {
                data: res,
                metadata: response.data.metadata,
                paginator: response.data.paginator,
            };
        });
    }

    get(id: Number, params?: Object): Promise<ImportMetadata> {
        return this.getResource(id, params).then(function (response) {
            return new ImportMetadata(response.data.data);
        });
    }

    save(importMetadata: ImportMetadata, params?: Object): Promise<ImportMetadata> {
        return super
            .saveResource(importMetadata.serialize(), params)
            .then(function (response) {
                return new ImportMetadata(response.data.data);
            });
    }

    delete(id: Number): Promise<ImportMetadata> {
        return super.deleteResource(id).then(function (response) {
            return new ImportMetadata(response.data.data);
        });
    }
}